import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { useNavigate } from "react-router-dom";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { selectListItems } from "../../../../../../redux/library/selector";
import { selectPlansListItems } from "../../../../../../redux/plans/selector";
import { plans } from "../../../../../../redux/plans/action";
import PageLoader from "../../../../../../components/PageLoader";
import Table from "../../../../../../common/components/table";
import { prepares } from "../../../../../../redux/prepares/action";


const AgencyTemplates = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const result = useSelector(selectCurrent)
  const itemsData = useSelector(selectPlansListItems)
  const libraryData = useSelector(selectListItems)
  const [columnDefs, setColumnDefs] = useState({});


  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Plan', searchField: 'Name', sortable: true, filter: true, filterType: 'text' },
      {
        field: 'TemplateTypeId',
        headerName: 'Template',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.TemplateType },
        sortable: true,
        filter: true
      },

      { field: 'IsApproved', headerName: 'Approved', cellRenderer: 'yesNoRenderer' },

    ]);
  }

  
  const fetchPlan = () => {
    dispatch(plans.list({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/templates/list`,
      entity: 'plans',
      jsonData: {

     
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc"
      }
    }))
  }

  useEffect(() => {
    createColumnDefs()
    fetchPlan()
  }, [pageData, pageSize])

  const handleDelete = (data: any) => {
    dispatch(prepares.delete({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/templates/delete`,
      entity: 'prepares',
      jsonData: {
        Records: [
          {
            Id: data?.Id
          }
        ]
      }
    })).then(() => {
      fetchPlan()
    });
  }
  const handleEditTemplate = (type: string, data: any) => {
    navigate(`${type}/${data.Id}`)
  }
  const handleEdit = (data: any) => {

    if (data.TemplateTypeId === 30) {
      handleEditTemplate('email', data)
    } else if (data.TemplateTypeId === 40) {
      handleEditTemplate('sms', data)
    } 
    console.log(data, 'data')
  }

  const editButtons: any = [
    {
      name: 'Edit Email Template',
      callback: () => handleEdit('email'),
    },
    {
      name: 'Edit SMS Template',
      callback: () => handleEdit('sms'),
    },
   

  ];

  const handleAddTemplate = (type: string) => {
    navigate(`${type}/${0}`)
  }

  const additionButtons: any = [
    {
      name: 'New Email Template',
      callback: () => handleAddTemplate('email'),
    },
    {
      name: 'New SMS Template',
      callback: () => handleAddTemplate('sms'),
    },
  ];

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(prepares.list({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/templates/list`,
      entity: 'prepares',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }

  return (
    <>
      {itemsData?.isLoading ?
        <PageLoader /> :
        <Table columnData={columnDefs}    rowData={
    itemsData?.result?.items?.filter(
      (item: any) =>
        [30, 40].includes(item.TemplateTypeId)
    )
  } setPageData={setPageData} setPageSize={setPageSize} onEdit={handleEdit} enableFilter={true}
          onDelete={handleDelete} onSearch={handleSearch} additionButtons={additionButtons} headingName="Prepare Templates" />
      }
    </>
  );
};

export default AgencyTemplates;


